import React from "react";
import { RiLoader5Fill } from "react-icons/ri";

const Button = ({
  type,
  onClick,
  icon,
  children,
  className,
  animate,
  disabled,
  loading,
}) => {
  const getBtnStyle = () => {
    switch (type) {
      case "primary":
        return "bg-blue-600 hover:bg-blue-900 text-white font-bold ";
      case "ghost":
        return "bg-gray-400  text-blue-900 bg-opacity-25 hover:bg-opacity-25 hover:bg-gray-500 font-bold ";
      case "link-thin":
        return "text-blue-900 hover:text-blue-600 ";
      case "link":
        return "text-blue-900 hover:text-blue-600 font-bold";
      case "outline":
        return "border border-blue-600 text-blue-600 hover:text-blue-900 hover:border-blue-900 font-bold ";
      case "danger":
        return "bg-red-500 hover:bg-red-600 text-white font-bold ";
      case "danger-ghost":
        return "bg-red-200  text-red-600 bg-opacity-25 hover:bg-opacity-25 hover:bg-red-300 font-bold ";
      case "danger-link":
        return "text-red-600 hover:text-red-500 font-bold";
      case "danger-outline":
        return "border border-red-500 text-red-500 hover:text-red-600 hover:border-red-600 font-bold ";
      default:
        return "bg-blue-600  text-white font-bold";
    }
  };

  return (
    <button
      onClick={onClick}
      className={`flex py-2 desktop:px-4  laptop:px-3  mobile:px-2 items-center  rounded-md transition duration-200 ease-in-out cursor-pointer focus:outline-none focus:shadow-none ${getBtnStyle()} ${className} ${
        animate && "animate-breathe"
      } ${disabled && "pointer-events-none opacity-50 cursor-not-allowed"}`}
    >
      {(icon || loading) && (
        <span
          className={`${
            children && "laptop:mr-2 mobile:mr-1"
          } text-lg desktop:text-xl ${loading === true && "animate-spin"}`}
        >
          {loading ? <RiLoader5Fill /> : icon}{" "}
        </span>
      )}
      <span className="shrink-0 text-sm desktop:text-base">{children}</span>
    </button>
  );
};

export default Button;
